import React from "react";
import { StaticHeaderNavBarLight } from "components/HeaderNavBar/HeaderNavBarLight";

import getUrlsByLanguage from "src/urls/urls";
import { AlternateLink } from "src/utils/localization/alternateLinks";
import { Language } from "src/utils/localization/languages/types";

interface LightNavBarProps {
  language: Language;
  alternateLinks: AlternateLink[];
}

const LightNavBar: React.FC<LightNavBarProps> = ({ language }) => {
  const navigationLinks = getUrlsByLanguage(language.code);

  return (
    <StaticHeaderNavBarLight
      navigationLinks={navigationLinks}
      language={language}
    />
  );
};

export default React.memo(LightNavBar);
